const removeCnpjCharacteres = (cnpj) => {
  return cnpj.match(/\d/g).join('')
}

const spanIsObsoleted = (value) => {
  if (value === '0') {
    return '<span class="badge bg-success">Não</span>'
  }
  return '<span class="badge bg-danger">Sim</span>'
}

export { removeCnpjCharacteres, spanIsObsoleted }
